import { render, staticRenderFns } from "./CardLive.vue?vue&type=template&id=435679d1&scoped=true&"
import script from "./CardLive.vue?vue&type=script&lang=js&"
export * from "./CardLive.vue?vue&type=script&lang=js&"
import style0 from "./CardLive.vue?vue&type=style&index=0&id=435679d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435679d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VSpacer})
